import { render } from "./facebook.svg?vue&type=template&id=488e829c"
const script = {}
script.render = render

export default script